import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { ClassInfo } from '../types';

interface ClassEditModalProps {
  isOpen: boolean;
  classInfo: ClassInfo | null;
  onSave: (classId: number, newName: string) => void;
  onClose: () => void;
}

export const ClassEditModal: React.FC<ClassEditModalProps> = ({
  isOpen,
  classInfo,
  onSave,
  onClose
}) => {
  const [className, setClassName] = useState('');

  useEffect(() => {
    if (classInfo) {
      setClassName(classInfo.name);
    }
  }, [classInfo]);

  if (!isOpen || !classInfo) return null;

  const handleSave = () => {
    if (className.trim()) {
      onSave(classInfo.id, className.trim());
      onClose();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-96">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-900">Edit Class Name</h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Class ID: {classInfo.id}
          </label>
          <input
            type="text"
            value={className}
            onChange={(e) => setClassName(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Enter class name"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            autoFocus
          />
        </div>

        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={!className.trim()}
            className="px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg transition-colors"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};